import templateUrl from './trip-planner-mobile-help.html';

export const tripPlannerMobileHelpComponent = {
    bindings:{
        primaryContactNumber: '<',
        onBack: '&'
    },

    templateUrl,

    controller: class TripPlannerMobileHelpComponent {
    }
};


// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner-mobile-help/trip-planner-mobile-help.component.js